'use client';
import { getDefaultZIndex } from '@s7/styles';

const IDENT = 'Overlay';
const OPACITY_PROPERTY = '--opacity';
const defaultProps = {
    opacity: 0.6,
    color: '#000',
    zIndex: getDefaultZIndex('modal'),
    radius: 0
};

export { IDENT, OPACITY_PROPERTY, defaultProps };
//# sourceMappingURL=Overlay.contract.js.map
